// antd v5 静态方法（message / notification / Modal.confirm）在 React 19 下不渲染：
// 它们依赖 React 18 的 legacy ReactDOM.render 路径，React 19 已移除 → 调用静默失败
// （实测粘贴非法文件 / upload 超 10MB 都不弹 toast，DOM 无 .ant-message holder）。
// antd 官方解法：用 unstableSetRender 注册基于 react-dom/client createRoot 的渲染器，
// 等价 @ant-design/v5-patch-for-react-19，但内联避免给消费方新增依赖。
// 副作用模块：被组件库入口 import 一次即全局生效，无需改动任何 message 调用点。
import { unstableSetRender } from 'antd';
import { createRoot, type Root } from 'react-dom/client';

type RootHostElement = Element | DocumentFragment;
type ContainerWithRoot = RootHostElement & { _reactRootForAntd?: Root };

unstableSetRender((node, container) => {
  const host = container as ContainerWithRoot;
  host._reactRootForAntd ||= createRoot(host);
  const root = host._reactRootForAntd;
  root.render(node);
  // 卸载需放到下一帧：React 19 不允许在 render 周期内同步 unmount 同一 root
  return async () => {
    await new Promise((resolve) => setTimeout(resolve, 0));
    root.unmount();
  };
});
